/**
 * Number Formatter Utility
 * Provides locale-aware number formatting with thousand separators
 * English locales use comma (1,123), all others use dot (1.123)
 */

(function() {
  'use strict';

  // Get current locale from Shopify (will be set by Liquid template)
  const getCurrentLocale = function() {
    // This will be set by the theme.liquid inline script
    if (window._21eCurrentLocale) {
      return window._21eCurrentLocale;
    }
    // Fallback: try to detect from document or shopify
    if (window.Shopify && window.Shopify.locale) {
      return window.Shopify.locale.toLowerCase();
    }
    // Try to get from document lang attribute
    if (document.documentElement && document.documentElement.lang) {
      return document.documentElement.lang.split('-')[0].toLowerCase();
    }
    // Default to English
    return 'en';
  };

  // Extract base locale code (e.g., 'de' from 'de-DE')
  const getBaseLocale = function(locale) {
    if (!locale) return 'en';
    return locale.split('-')[0].toLowerCase();
  };

  /**
   * Format a number with locale-specific thousand separators
   * @param {number} number - The number to format
   * @param {string} [locale] - Optional locale override (defaults to current locale)
   * @returns {string} Formatted number string
   */
  const formatNumber = function(number, locale) {
    const rounded = Math.round(number);
    const currentLocale = locale || getCurrentLocale();
    const baseLocale = getBaseLocale(currentLocale);
    
    // Check if locale is English (en, gb, us, ca, or empty/undefined defaults to English)
    const englishLocales = ['en', 'gb', 'us', 'ca'];
    const isEnglish = !baseLocale || baseLocale === '' || englishLocales.includes(baseLocale);
    
    if (isEnglish) {
      // English: use comma separator
      return rounded.toLocaleString('en-US');
    } else {
      // Non-English: use dot separator (German format)
      // Use Intl.NumberFormat with explicit grouping separator
      const formatter = new Intl.NumberFormat('de-DE', {
        useGrouping: true,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return formatter.format(rounded);
    }
  };

  // Export to global scope
  window._21eNumberFormatter = {
    formatNumber: formatNumber,
    getCurrentLocale: getCurrentLocale,
    getBaseLocale: getBaseLocale
  };

})();

